import { IconButton, NameContainer } from 'pages/ArchVisionAdminDashboard/styles';
import { FovTypography, PeopleOutlined } from 'components';


export const listColumns = (theme, selectedTheme, setSelectedClient) => ([
    {
        title: 'Client Name',
        key: 'name',
        width: 300,
        alignContent: 'left',
        render: (text, client) => {
            return (
                <NameContainer>
                    <div>{client.display_name}</div>
                    <FovTypography fontSize={12}>({client.client_id})</FovTypography>
                </NameContainer>
            );
        },
    },
    {
        title: 'Client Profile',
        key: 'client_profile',
        width: 50,
        alignContent: 'center',
        render: (text, client) => (
            <IconButton
                theme={theme}
                $selectedTheme={selectedTheme}
                onClick={() => {
                    setSelectedClient(client);
                }}
                icon={<PeopleOutlined theme={theme} $selectedTheme={selectedTheme} />}
            />
        ),
    },
]);